import { MultiplePropertyListingDto, PropertyListingDto, TaskListDto, UserDto } from 'src/app/services/property-matrixV2/models';
import { LookupService, PropertyListingService, UserManagementService } from 'src/app/services/property-matrixV2/services';
import { ListingStateService } from 'src/app/shared/services/listing-state-service/listing-state.service';
import { NotificationService } from 'src/app/shared/services/notification-service/notification.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, finalize, of } from 'rxjs';

@Component({
  selector: 'app-allocate-network-planner',
  templateUrl: './allocate-network-planner.component.html',
  styleUrls: ['./allocate-network-planner.component.scss', '../../../../../../../css/2-modules/_admin-portal.scss']
})
export class AllocateNetworkPlannerComponent implements OnInit {

  @Input() selectedListing: PropertyListingDto;
  @Input() selectedListingGroup: MultiplePropertyListingDto;

  sections = [
    { key: 1, value: 'Agent listing', checked: true },
    { key: 2, value: 'Network Planner Status', checked: true },
    { key: 3, value: 'Allocate Planner', checked: true },
  ];

  isNetworkPlannerNominated: boolean = false;
  selectedNetworkPlanner: UserDto = null;
  user: UserDto = null;
  UserList: UserDto[] = [];
  UserListNew: UserDto[] = [];
  FormAllocateNetworkPlanner: FormGroup;
  networkPlannerType = 1;
  listingType: string;
  currentUser: UserDto;
  loading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private userManagementService: UserManagementService,
    private lookupService: LookupService,
    private listingStateService: ListingStateService,
    private propertyListingService: PropertyListingService,
    private router: Router,
    private notificationService: NotificationService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.listingType = params['listingType'];
    });
    this.getCurrentUser();
    this.getNetworkPlannerUserList();
    this.prepareFormFields();
    this.checkIfAnyNetworkPlannerNominated();
  }

  getNetworkPlannerUserList(): void {
    try {
      this.loading = true;
      this.lookupService.apiV1LookupGetNetworkPlannerUsersGet()
        .pipe(
          catchError((err) =>
            of(this.notificationService.showErrorMessage("Error", "Could not load Network/Urban planner user list items for users."))
          ),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((userList: UserDto[]) => {
          this.UserListNew = userList;
        });
    }
    catch (e) {
      this.notificationService.showErrorMessage('Error', 'Could not load Network/Urban planner user list items for users.');
    }
  }

  collapseOrExpandSection(section: { checked: boolean; }) {
    section.checked = !section.checked;
  }

  prepareFormFields(): void {
    this.FormAllocateNetworkPlanner = this.fb.group({
      plannerName: ["", [Validators.required]],
      plannerSurname: ["", [Validators.required]],
      plannerCompany: ["", [Validators.required]],
      plannerCityTown: ["", [Validators.required]],
      plannerEmail: ["", [Validators.required]],
      plannerMobileOfficeNr: ["", [Validators.required]],
    });
    this.selectedNetworkPlanner = null;
  }

  saveNetworkPlanner(): void {
    try {
      if (this.selectedNetworkPlanner != null) {
        this.selectedListing.networkPlanner = this.selectedNetworkPlanner;

        this.propertyListingService.apiV1PropertyListingAddOrUpdateNetworkPlannerToPropertyListingPost({
          body: this.selectedListing
        })
          .pipe(
            catchError((err) =>
              of(this.notificationService.showErrorMessage("Error", "Could not save Network/Urban planner user."))
            ),
            finalize(() => {
              this.loading = false;
            })
          )
          .subscribe((result: any) => {
            this.notificationService.showSuccessMessage("Save", 'Added Network/Urban planner user to current listing successfully and task is complete.');
            this.setPropertyListingTask();
          });
      } else {
        this.notificationService.showWarningMessage("Please select Network/Urban planner.", "No Network/Urban planner user selected.");
      }
    }
    catch (e) {
      this.notificationService.showErrorMessage('Error', 'Could not load Network/Urban planner user list items for users.');
    }
  }

  checkIfAnyNetworkPlannerNominated(): void {
    if (this.selectedListing.networkPlanner) {
      this.isNetworkPlannerNominated = false;
      this.FormAllocateNetworkPlanner.get("plannerName").setValue(this.selectedListing.networkPlanner.name);
      this.FormAllocateNetworkPlanner.get("plannerSurname").setValue(this.selectedListing.networkPlanner.surname);
      this.FormAllocateNetworkPlanner.get("plannerCompany").setValue(this.selectedListing.networkPlanner.profession);
      this.FormAllocateNetworkPlanner.get("plannerCityTown").setValue(this.selectedListing.addressTitle);
      this.FormAllocateNetworkPlanner.get("plannerEmail").setValue(this.selectedListing.networkPlanner.email);
      this.FormAllocateNetworkPlanner.get("plannerMobileOfficeNr").setValue(this.selectedListing.networkPlanner.mobile);
      this.selectedNetworkPlanner = this.selectedListing.networkPlanner;
    } else {
      this.isNetworkPlannerNominated = true;
    }
  }

  navigateToPlanningReport() {
    this.propertyListingService.apiV1PropertyListingGetPropertyListingByIdGet({ listingId: this.selectedListing.id }).subscribe(result => {
      this.selectedListing = result;
      this.listingStateService.setSelectedListing(this.selectedListing);
      this.router.navigate(['admin/listings/listing-overview'], {
        queryParams: {
          listingType: this.listingType
        }
      });
    });
  }

  setPropertyListingTask(): void {
    try {
      let changedTaskLists = [] as TaskListDto[];

      let taskStatusComment = "";
      if (this.networkPlannerType == 1) {
        taskStatusComment = "Allocated by PM";
      } else if (this.networkPlannerType == 2) {
        taskStatusComment = "Nominated by Seller";
      } else if (this.networkPlannerType == 3) {
        taskStatusComment = "NP referred property";
      }

      this.selectedListing.taskList.forEach(task => {
        if (task.taskNumber.number === 6) {
          if (task.taskStatus.taskStatusNumber != 3) {
            task.user = this.currentUser;
            changedTaskLists.push(task);
          }
        }
        if (task.taskNumber.number === 7) {
          if (task.taskStatus.taskStatusNumber == 1) {
            task.user = this.selectedNetworkPlanner;
            task.userStatusText = taskStatusComment;
            changedTaskLists.push(task);
          }
        }
      });

      if (changedTaskLists.length > 0) {
        this.propertyListingService.apiV1PropertyListingUpdatePropertyListingTaskPost({ body: changedTaskLists, currentTaskNumber: 6 }).subscribe(result => {
          if (result != null) {
            this.navigateToPlanningReport();
          }
          else {
            this.notificationService.showErrorMessage('Error', 'Failed to update planners.');
          }
        });
      }
      else {
        this.navigateToPlanningReport();
      }
    }
    catch (e) {
      this.notificationService.showErrorMessage('Error', 'Failed to update planners.');
    }
  }

  getCurrentUser(): void {
    this.userManagementService.apiV1UserManagementGetCurrentUserGet().subscribe(result => {
      if (result != null) {
        this.currentUser = result;
      }
      else {
        this.notificationService.showWarningMessage('No Current User', 'No current user found.');
      }
    });
  }

  compareNetworkPlanner(planner1: UserDto, planner2: UserDto) {
    return planner1 && planner2 ? planner1.name === planner2.name : planner1 === planner2;
  }
}
